import script from "./EditRoles.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditRoles.vue?vue&type=script&setup=true&lang=ts"

import "./EditRoles.vue?vue&type=style&index=0&id=5594222b&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5594222b"]])

export default __exports__